/**
 * Code modified from Bootstrap, modal.js version 3.3.1
 */
var $ = require('jquery');

// MODAL CLASS DEFINITION
// ======================

var Modal = function(element, options) {
  // eslint-disable-next-line eqeqeq
  this.options = $.extend({}, Modal.DEFAULTS, typeof options == 'object' && options);
  this.$body = $(document.body);
  this.$element = element;
  this.$backdrop = null;
  this.isShown = null;
  this.scrollbarWidth = 0;
};

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

Modal.DEFAULTS = {
  backdrop: true,
  keyboard: true
};

Modal.prototype.toggle = function(_relatedTarget) {
  return this.isShown ? this.hide() : this.show(_relatedTarget);
};

Modal.prototype.show = function(_relatedTarget) {
  var that = this;
  var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget });

  this.$element.trigger(e);

  if (this.isShown || e.isDefaultPrevented()) return;

  this.isShown = true;

  this.checkScrollbar();
  this.setScrollbar();
  this.$body.addClass('modal-open');

  this.escape();
  this.resize();

  this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));

  this.backdrop(function() {
    var transition = $.support.transition && that.$element.hasClass('fade');

    if (!that.$element.parent().length) {
      that.$element.appendTo(that.$body); // don't move modals dom position
    }

    that.$element
      .show()
      .scrollTop(0);

    if (that.options.backdrop) that.adjustBackdrop();
    that.adjustDialog();

    if (transition) {
      that.$element[0].offsetWidth; // force reflow
    }

    that.$element
      .addClass('in')
      .attr('aria-hidden', false);

    that.enforceFocus();

    var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget });

    transition ?
      that.$element.find('.modal-dialog') // wait for modal to slide in
        .one('bsTransitionEnd', function() {
          that.$element.trigger('focus').trigger(e);
        })
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      that.$element.trigger('focus').trigger(e);
  });
};

Modal.prototype.hide = function(e) {
  if (e) e.preventDefault();

  e = $.Event('hide.bs.modal');

  this.$element.trigger(e);

  if (!this.isShown || e.isDefaultPrevented()) return;

  this.isShown = false;

  this.escape();
  this.resize();

  $(document).off('focusin.bs.modal');

  this.$element
    .removeClass('in')
    .attr('aria-hidden', true)
    .off('click.dismiss.bs.modal');

  $.support.transition && this.$element.hasClass('fade') ?
    this.$element
      .one('bsTransitionEnd', $.proxy(this.hideModal, this))
      .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
    this.hideModal();
};

Modal.prototype.enforceFocus = function() {
  $(document)
    .off('focusin.bs.modal') // guard against infinite focus loop
    .on('focusin.bs.modal', $.proxy(function(e) {
      if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
        this.$element.trigger('focus');
      }
    }, this));
};

Modal.prototype.escape = function() {
  if (this.isShown && this.options.keyboard) {
    this.$element.on('keydown.dismiss.bs.modal', $.proxy(function(e) {
      // eslint-disable-next-line eqeqeq
      e.which == 27 && this.hide();
    }, this));
  } else if (!this.isShown) {
    this.$element.off('keydown.dismiss.bs.modal');
  }
};

Modal.prototype.resize = function() {
  if (this.isShown) {
    $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this));
  } else {
    $(window).off('resize.bs.modal');
  }
};

Modal.prototype.hideModal = function() {
  var that = this;
  this.$element.hide();
  this.backdrop(function() {
    that.$body.removeClass('modal-open');
    that.resetAdjustments();
    that.resetScrollbar();
    that.$element.trigger('hidden.bs.modal');
  });
};

Modal.prototype.removeBackdrop = function() {
  this.$backdrop && this.$backdrop.remove();
  this.$backdrop = null;
};

Modal.prototype.backdrop = function(callback) {
  var that = this;
  var animate = this.$element.hasClass('fade') ? 'fade' : '';

  if (this.isShown && this.options.backdrop) {
    var doAnimate = $.support.transition && animate;

    this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
      .prependTo(this.$element)
      .on('click.dismiss.bs.modal', $.proxy(function(e) {
        if (e.target !== e.currentTarget) return;
        // eslint-disable-next-line eqeqeq
        this.options.backdrop == 'static' ? this.$element[0].focus.call(this.$element[0])
          : this.hide.call(this);
      }, this));

    if (doAnimate) this.$backdrop[0].offsetWidth; // force reflow

    this.$backdrop.addClass('in');

    if (!callback) return;

    doAnimate ?
      this.$backdrop
        .one('bsTransitionEnd', callback)
        .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
      callback();

  } else if (!this.isShown && this.$backdrop) {
    this.$backdrop.removeClass('in');

    var callbackRemove = function() {
      that.removeBackdrop();
      callback && callback();
    };
    $.support.transition && this.$element.hasClass('fade') ?
      this.$backdrop
        .one('bsTransitionEnd', callbackRemove)
        .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
      callbackRemove();

  } else if (callback) {
    callback();
  }
};

// these following methods are used to handle overflowing modals

Modal.prototype.handleUpdate = function() {
  if (this.options.backdrop) this.adjustBackdrop();
  this.adjustDialog();
};

Modal.prototype.adjustBackdrop = function() {
  this.$backdrop
    .css('height', 0)
    .css('height', this.$element[0].scrollHeight);
};

Modal.prototype.adjustDialog = function() {
  var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight;

  this.$element.css({
    paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
    paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
  });
};

Modal.prototype.resetAdjustments = function() {
  this.$element.css({
    paddingLeft: '',
    paddingRight: ''
  });
};

Modal.prototype.checkScrollbar = function() {
  this.bodyIsOverflowing = document.body.scrollHeight > document.documentElement.clientHeight;
  this.scrollbarWidth = this.measureScrollbar();
};

Modal.prototype.setScrollbar = function() {
  var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10);
  if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth);
};

Modal.prototype.resetScrollbar = function() {
  this.$body.css('padding-right', '');
};

Modal.prototype.measureScrollbar = function() { // thx walsh
  var scrollDiv = document.createElement('div');
  scrollDiv.className = 'modal-scrollbar-measure';
  this.$body.append(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  this.$body[0].removeChild(scrollDiv);
  return scrollbarWidth;
};

module.exports = Modal;

require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/ui-modal/src/modal.less');